import React from 'react';
import logo from "../../assets/images/logoky.png"
import file from "../../assets/Amrut _Cup_2025_Rule_Book.pdf"
import { Button } from 'reactstrap';

const Rules = () => (
  <div className="content">
    {/* <img src={rule1} roundedCircle /> 
    <img src={rule2} roundedCircle /> 
    <img src={rule3} roundedCircle />  */}

    {/* Amrut cup rules 
     <ul>
      <li>Each game will be 21 points rally scoring. No deuce in the game, whichever team reaches 21 first wins.</li>
      <li>Each team cannot have more than 3 Kishores / Yuvaks on the court. No limit for Vadil participants.</li>
      <li>Players below age of 15 years or above 60 years is not allowed to participate. </li>
      <li>Players with age &ge; 15 years and &le; 31 year will be considered as kishore/yuvak </li>
      <li>Member/s of a team cannot be swapped with another team.</li>
      <li>Minimum 5 and Maximum 6 players allowed on the court.</li>
      <li>Point Counts including On the line/Service Net.(Keep Playing)</li>
      <li>Net touch and / or Carry calls will be made by Referee. </li>
      <li>Maximum 3 hits allowed in each side.</li>
      <li>All balls must go over the net.</li>
      <li>Substitution is allowed only during the service turn of a given team. </li>
      <li>One player can not continue service; no need for player rotation</li>
      <li>Service cannot be blocked.</li>
      <li>All Games must be completed within 20 minutes time. Team wil be warned before 2 mins to finish.</li>
      <li>Each team must be present 5 mins before their schedule game time. Waiting time is only for 5 mins from schedule time else team present at the court would proceed for next round.</li>
      <li>No points will be given to absentee team. </li>
      <li>Sports shoes are mandatory.</li>
      <li>All players should be attending Satsang Sabha regularly, atleast once a month.</li>
      <li>If ball touches ceiling and ball in the same side of the team then ball is still live; but if ball reaches to other side then its the team for other team.</li>
      <li>Max one 30 seconds timeout allowed for each team in a game.</li>
    </ul> */
    /* Amrut Cup rules as below */
 
      <div  id="container">
        <form method="get" action={file}>
          <Button color="primary" type="submit">Download rule book</Button>
        </form>
        {/* <div id="background" className="text-center w-100">
          <img src={logo} width={350} height={500} alt={"logo"} className="photo backdrop-img" />
        </div>
        <ul>
          <li> Each game will be 21 points rally scoring. No deuce in the game, whichever team reaches 21 first wins.</li>
          <li> Each team will consist of players from Seva Team (If your team doesnt have enough, we will consolidate teams).</li>
          <li> Member/s of a team cannot be swapped with another team (Once the games have begun).</li>
          <li> Maximum 6 players allowed on the court.</li>
          <li> Point Counts including On the line/Service Net. (Keep Playing)</li>
          <li> Net touch and / or Carry calls will be made by Referee.</li>
          <li> Maximum 3 hits allowed in each side.</li>
          <li> All balls must go over the net.</li>
          <li> Substitution is allowed only during the service turn of a given team.</li>
          <li> One player can not continue service; no need for player rotation</li>
          <li> Service cannot be blocked.</li>
          <li> All Games must be completed within 20 minutes time. Team will be warned before 2 mins to finish.</li>
          <li> Each team must be present 5 mins before their schedule game time. Waiting time is only for 5 mins from schedule time else team present at the court would proceed for next round.</li>
          <li> No points will be given to absentee team.</li>
          <li> Sports shoes are mandatory.</li>
          <li> If ball touches ceiling and ball in the same side of the team then ball is still live; but if ball reaches to other side then its the team for other team.</li>
          <li> Max one 30 seconds timeout allowed for each team in a game.</li>
          <li> If it’s time off then the team with highest point will win. Warning will be given 2 mins in advance by referee</li>
        </ul> */}
      </div>
    }

  </div>
);

export default Rules;


// WEBPACK FOOTER //
// ./src/pages/Rules/index.js